export default { sha: '99a6d333bb7c67b3260034018f4a719f5606314d', buildNumber: 'undefined' }
